// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"94":"Login","231":"Meal Plan","274":"Home","827":"Signup"}[chunkId] || chunkId) + "." + {"38":"fade414b","94":"061c05cb","229":"7e5d64d9","231":"bae3313d","274":"139ec123","453":"1e793dec","516":"f4daa816","586":"4e1b1ab0","827":"69dbd209","852":"c23cfec8"}[chunkId] + ".chunk.js";
};